import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createCustomer } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { SessionService } from '../../../../user/session/SessionService';

export const useCustomerCreate = () => {
    const queryClient = useQueryClient();
    const { getAccessTokenSilently } = useAuth0();

    return useMutation({
        mutationFn: createCustomer,
        onSuccess: async () => {
            // Force Auth0 to fetch a fresh access token and bypass the cache.
            const accessToken = await getAccessTokenSilently({ cacheMode: 'off' });
            const freshRoleData = await SessionService.getInstance().loadRoleInformation(accessToken);
            queryClient.setQueryData(queries.role.information.queryKey, freshRoleData);
            return queryClient.invalidateQueries({ queryKey: queries.customers._def });
        },
    });
};
